import FTLTable from "./components/FTLTable";
export default FTLTable;
//# sourceMappingURL=index.js.map